import AlertDialog from "./AlertDialog";

const alert = async (message?: string, title?: string) => {
	const dialog = new AlertDialog({
		message: message,
		title: title,
		controls: "close-only",
		buttons: [{
			text: "OK",
			click: () => {
				dialog.dismiss();
			}
		}]
	});
	await dialog.show();
};

export default alert;
